import { isNil } from 'lodash'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { Alert } from 'features/alerts/types/alert'
import { DomainDTO } from 'features/inventory/api/types/domainDTO'
import { PageDTO } from 'features/inventory/api/types/pageDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { Page } from 'features/inventory/types/page'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

type Data = {
  node: null | {
    domain: Pick<DomainDTO, 'alerts'>
  }
}
type Variables = {
  id: PageDTO['id']
}

export const useGetFreshPageDomainAlerts = ({
  pageId,
}: {
  pageId?: Page['id']
}): Alert<DomainAlert>[] => {
  const { data } = useQuery<Variables, Data, Alert<DomainAlert>[]>({
    options: {
      enabled: pageId !== undefined,
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
      select: ({ node }: Data): Alert<DomainAlert>[] => {
        if (isNil(node)) {
          return []
        }

        return alertsFromDTO<DomainAlert>(node.domain.alerts)
      },
    },
    query: gql`
      query getFreshPageDomainAlerts($id: ID!) {
        node(id: $id) {
          ... on Page {
            domain {
              alerts {
                name
                description
              }
            }
          }
        }
      }
    `,
    variables: { id: pageId! },
  })

  return data ?? []
}
